enum Page {
    Agent = "/main/agent",
    Agents = "/main/agents",
    AgentGroups = "/main/agent-groups",
    Anomalies = "/main/anomalies",
    Anomaly = "/main/anomaly",
    Authenticate = "/authenticate",
    AuthenticateRefresh = "/authenticate-refresh",
    CustomReports = "/main/custom-reports",
    Explore = "/main/explore",
    ExploreTags = "/main/explore-tags",
    Interaction = "/main/interaction",
    Live = "/main/live",
    Login = "/",
    Main = "/main",
    ManageTags = "/main/manage-tags",
    ManagePhraseTriggers = "/main/manage-tags/:tagId/phrase-triggers",
    PhraseTriggersReport = "/main/manage-tags/:tagId/phrase-triggers/:phraseTriggerId/report",
    Permissions = "/main/permissions",
    SpellingConfiguration = "/main/spelling-configuration",
    Users = "/main/users",
}

export default Page;
